/**
 * Model for Process related activities.
 */
export class Process {
    id: number;
    name: string;
    key: string;
    description: string;
    resourceName: string;
    version: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/process.model.ts